import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import { FiMessageSquare } from "react-icons/fi";

// Picha inaitwa hapa kwenye JSX pekee kwa ajili ya background ya Ribbon
import bgCtaRibbon from '../assets/prisoners.jpg';

export default function CallToAction(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.homeCTA;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Space for initialization if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div 
                className="MainBodySection premium-cta-ribbon position-relative d-flex align-items-center"
                // style={{ backgroundImage: `url(${bgCtaRibbon})` }}
            >
                {/* Sleek Gradient Overlay combining Primary and Dark tones with low opacity */}
                <div className="cta-ribbon-overlay"></div>

                <div className="container position-relative z-index-3">
                    <div className="row align-items-center justify-content-between">
                        
                        {/* Left Side: Short Punchy Core Statement */}
                        <div className="col-12 col-md-8 text-center text-md-start mb-3 mb-md-0">
                            <h3 className="title-font-semi-bold text-white cta-ribbon-heading mb-1">
                                {s.heading[language]}
                            </h3>
                            <p className="font-regular text-white-75 cta-ribbon-submb-0">
                                {s.description[language]}
                            </p>
                        </div>

                        {/* Right Side: Ultra Clean Premium Action Trigger */}
                        <div className="col-12 col-md-4 text-center text-md-end">
                            <button 
                                className="btn btn-premium-cta-trigger title-font-semi-bold d-inline-flex align-items-center gap-2"
                                onClick={() => appContext.navTo({ item: 'contact_us' })}
                            >
                                <FiMessageSquare size={16} />
                                <span>{s.buttonText[language]}</span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}